import React, { useState } from 'react'
import {
    Box,
    Typography,
    Button,
    IconButton,
    Stack,
    ListItemAvatar,
    FormControl,
    Input,
    InputAdornment,
} from '@mui/material'
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import { getImages } from '../const';
import { useTheme } from '@emotion/react';
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import { useNavigate } from 'react-router-dom';
const steps = [
    'Invite Accepted',
    'Commited',
    'Confirm Payment',
    'Invested',
];
const InterestCommitmentModal = ({ handleClose, handleConfirmPayment }) => {
    const theme = useTheme();
    const navigate = useNavigate()

    const handleNavigation = (path) => {
        navigate(path);
    };
    return (
        <>
            <Box
                sx={{
                    mb: 1
                }}
            >

                <ListItemAvatar
                    sx={{
                        minWidth: '108px'
                    }}
                >
                    <img src={getImages('image6.png')} alt='' />
                </ListItemAvatar>
                <Stack direction="row"
                    sx={{
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        mb: 3
                    }}
                >
                    <Typography variant='h5'
                        sx={{
                            fontSize: "1.3rem",
                            color: "secondary.main",
                            fontWeight: "700"
                        }}>
                        Aalpha information systems <Box component="span" sx={{fontSize: '0.9rem', fontWeight: '600'}}>(Citizen Service)</Box>
                    </Typography>
                    <IconButton
                        sx={{
                            p: 0,
                            ml: 1
                        }}>
                        <OpenInNewOutlinedIcon sx={{ color: 'lightSecondary.main' }} />
                    </IconButton>
                </Stack>
            </Box>
            <Stack
                direction="row"
                sx={{
                    justifyContent: 'space-between',
                    mb: 3,
                    flexWrap: 'wrap',
                }}
            >
                <Box
                    sx={{
                        pr:2,
                        mb: 2
                    }}
                >
                    <Typography variant='h5'
                        sx={{
                            fontSize: "12px",
                            color: "ltheme.main",
                            fontWeight: "500",
                            mb: 0.5
                        }}>
                        Company Revenue
                    </Typography>
                    <Typography variant='h5'
                        sx={{
                            fontSize: "1rem",
                            color: "lightSecondary.main",
                            fontWeight: "600",
                        }}>
                        $500001 and Above USD
                    </Typography>
                </Box>
                <Box
                    sx={{
                        pr:2,
                        mb: 2
                    }}
                >
                    <Typography variant='h5'
                        sx={{
                            fontSize: "12px",
                            color: "ltheme.main",
                            fontWeight: "500",
                            mb: 0.5
                        }}>
                        Investment Stage
                    </Typography>
                    <Typography variant='h5'
                        sx={{
                            fontSize: "1rem",
                            color: "lightSecondary.main",
                            fontWeight: "600",
                        }}>
                        Pre-seed
                    </Typography>
                </Box>
                <Box>
                    <Typography variant='h6'
                        sx={{
                            fontSize: "12px",
                            color: "ltheme.main",
                            fontWeight: "500",
                            mb: 0.5
                        }}>
                        Total Funding Amount
                    </Typography>
                    <Typography variant='h5'
                        sx={{
                            fontSize: "1rem",
                            color: "lightSecondary.main",
                            fontWeight: "600",
                        }}>
                        $1000000 USD
                    </Typography>
                </Box>
            </Stack>
            <Box
                sx={{
                    mb: 2
                }}
            >
                <Typography variant='h5'
                    sx={{
                        fontSize: "12px",
                        color: "ltheme.main",
                        fontWeight: "500",
                        mb: 0.5
                    }}>
                    Interested Investment Amount($)
                </Typography>
                <FormControl variant="filled"
                    sx={{
                        width: '100%',
                        borderRadius: '4px',
                        backgroundColor: 'extraLTheme.main',
                        border: 'solid 1px #DBEBF8',
                        '& .MuiInputBase-root': {
                            backgroundColor: 'extraLTheme.main',
                        },
                        '& .MuiInputBase-input': {
                            fontSize: '0.9rem',
                            color: 'lightSecondary.main',
                            fontWeight: '500',
                            pt: 1.5,
                            pb: 1.5
                        },
                        '& .MuiInputBase-root:hover:not(.Mui-disabled, .Mui-error):before': {
                            border: 'none'
                        },
                        '& .MuiInputBase-root:hover:before': {
                            border: 'none'
                        },
                        '&:hover': {
                            borderColor: '#DBEBF8'
                        },
                        '& .MuiInputBase-root:before': {
                            border: 'none'
                        },
                        '& .MuiInputBase-root:after': {
                            border: 'none'
                        }
                    }}
                >
                    <Input
                        sx={{
                            width: '100%',
                            borderRadius: '4px',
                            backgroundColor: 'extraLTheme.main',
                            border: 'solid 1px #DBEBF8',
                            '& .MuiInputBase-input': {
                                fontSize: '0.9rem',
                                color: 'lightSecondary.main',
                                fontWeight: '500',
                                p: 1.5
                            },
                        }}
                        value='120000'
                        type='text'
                        placeholder=''
                        endAdornment={
                            <InputAdornment position="end"
                                sx={{
                                    pr: 1
                                }}
                            >
                                <IconButton
                                    sx={{
                                        p: 0.5
                                    }}
                                >
                                    <BorderColorOutlinedIcon
                                        sx={{ color: 'lightSecondary.main' }}
                                    />
                                </IconButton>
                            </InputAdornment>
                        }
                    />
                </FormControl>
            </Box>
            <Box
                sx={{
                    textAlign: 'center',
                    mb: 1,
                    mt: 5
                }}
            >
                <Button variant="outlined"
                    sx={{
                        textTransform: 'inherit',
                        p: "10px 25px",
                        width:'240px',
                        textAlign:'center',
                        borderWidth: '2px',
                        fontWeight: '600',
                        borderColor: 'primary.main',
                        boxShadow: 'none',
                        mr: 2,
                        '&:hover': {
                            borderWidth: '2px',
                        },
                        [theme.breakpoints.down('md')]: {
                            width:'auto',
                        },
                        [theme.breakpoints.down('sm')]: {
                            width:'100%',
                            mb: 2
                        },
                    }}
                    onClick={()=>{handleClose() , handleNavigation("/inbox") }}
                >
                    Go To Inbox
                </Button>
                <Button variant="contained"
                    onClick={handleConfirmPayment}
                    sx={{
                        textTransform: 'inherit',
                        p: "12px 25px",
                        width:'240px',
                        textAlign:'center',
                        borderWidth: '2px',
                        fontWeight: '600',
                        borderColor: 'primary.main',
                        boxShadow: 'none',
                        '&:hover': {
                            borderWidth: '2px',
                            boxShadow: 'none',
                        },
                        [theme.breakpoints.down('md')]: {
                            width:'auto',
                        },
                        [theme.breakpoints.down('sm')]: {
                            width:'100%',
                        },
                    }}
                >
                    Confirm Payment
                </Button>
                {/* Pending Confirmation Button */}
                {/* <Button variant="contained"
                    onClick={handleConfirmPayment}
                    sx={{
                        textTransform: 'inherit',
                        p: "12px 25px",
                        width:'240px',
                        textAlign:'center',
                        borderWidth: '2px',
                        fontWeight: '600',
                        backgroundColor: '#F7941F',
                        borderColor: '#F7941F',
                        boxShadow: 'none',
                        '&:hover': {
                            borderWidth: '2px',
                            boxShadow: 'none',
                            backgroundColor: '#d57708',
                        }
                    }}
                >
                    Pending Confirmation
                </Button> */}
            </Box>
        </>
    )
}

export default InterestCommitmentModal